export const UsersAssistant = {
    "Users": {
        items: [
            //Changing system UI
            {
                heading: 'Managing All Users',
                permissions: ['System Admin'],
                tags: ['users'],
                sections: [
                    {
                        description: 'To manage a user, Select the DrData facility',
                        styleAs: 'list',
                    },
                    {
                        description: 'From the menu select <b>Users</b>',
                        styleAs: 'list',
                    },
                    {
                        description: 'Search for the user you would like to manage',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the user management screen',
                        action: {
                            type: 'location',
                            value: '/sys-admin/users',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            {
                heading: 'Creating a new users on the system',
                permissions: ['System Admin'],
                tags: ['user', 'add', 'creat'],
                sections: [
                    {
                        description: 'To create a user, Select the DrData facility',
                        styleAs: 'list',
                    },
                    {
                        description: 'From the menu select <b>Users</b>',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the <b>Create New User</b> button',
                        styleAs: 'list',
                    },
                    {
                        description: 'Enter the users details and click next',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the users facilities and roles and click next',
                        styleAs: 'list',
                    },
                    {
                        description: 'Complete tasks and click next',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the user management screen',
                        action: {
                            type: 'location',
                            value: '/sys-admin/users',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}